import { useState } from "react";
import CustomSelectMenu from "./CustomSelectMenu";
import FormLabel from "@components/shared/FormLabel";

const hours = Array.from(Array(12).keys());
const minutes = Array.from(Array(60).keys());
const seconds = Array.from(Array(60).keys());

type Props = {
  selectedDurationInSeconds?: number;
  onDurationChanged?: (seconds: number) => void;
  label?: string;
};

function toHoursAndMinutes(totalSeconds: number) {
  const totalMinutes = Math.floor(totalSeconds / 60);

  const seconds = totalSeconds % 60;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return { h: hours, m: minutes, s: seconds };
}

function CustomDurationPicker(props: Props) {
  const [selectedHour, setSelectedHour] = useState(
    toHoursAndMinutes(props.selectedDurationInSeconds ?? 0).h,
  );
  const [selectedMinutes, setSelectedMinutes] = useState(
    toHoursAndMinutes(props.selectedDurationInSeconds ?? 0).m,
  );
  const [selectedSeconds, setSelectedSeconds] = useState(
    toHoursAndMinutes(props.selectedDurationInSeconds ?? 0).s,
  );

  function onChange(hour: number, min: number, sec: number) {
    props.onDurationChanged?.(hour * 60 * 60 + min * 60 + sec);
  }

  return (
    <div className="flex flex-col">
      {props.label && <FormLabel label={props.label} />}

      <div className="flex items-end gap-2 text-xs text-gray-500 dark:text-gray-400">
        <CustomSelectMenu
          options={hours}
          selected={selectedHour}
          onChange={(val) => {
            if (val !== null) {
              setSelectedHour(val);
              onChange(val, selectedMinutes, selectedSeconds);
            }
          }}
          selectHint="Hour"
          maxHeight="10rem"
          optionRender={(val) => val}
          selectedRender={(val) => <div className="w-4">{val}</div>}
        />
        hrs
        <CustomSelectMenu
          options={minutes}
          selected={selectedMinutes}
          onChange={(val) => {
            if (val !== null) {
              setSelectedMinutes(val);
              onChange(selectedHour, val, selectedSeconds);
            }
          }}
          selectHint="Minutes"
          maxHeight="10rem"
          optionRender={(val) => val}
          selectedRender={(val) => <div className="w-4">{val}</div>}
        />
        mins
        <CustomSelectMenu
          options={seconds}
          selected={selectedSeconds}
          onChange={(val) => {
            if (val !== null) {
              setSelectedSeconds(val);
              onChange(selectedHour, selectedMinutes, val);
            }
          }}
          selectHint="Seconds"
          maxHeight="10rem"
          optionRender={(val) => val}
          selectedRender={(val) => <div className="w-4">{val}</div>}
        />
        s
      </div>
    </div>
  );
}

export default CustomDurationPicker;
